import React, { FC, useContext } from 'react';
import { Box } from '@ch/common/components/box';
import { IconPrinter } from '@ch/common/components/icon';
import { Heading } from '@ch/common/components/heading';
import { Text } from '@ch/common/components/text';
import { Button } from '@ch/common/components/button';
import { useData } from '../use-data';
import { QuizConfirmationImg, QuizInner, QuizStyledLink } from './quiz.styled';
import { QuizContext } from './quiz-context';
import { assetsPath } from '../const';
import { Route } from '@ch/common/const/route';

const QuizFieldGroupConfirm: FC = () => {
  const { intakeId } = useContext(QuizContext);

  const {
    data: {
      confirmation: { thankyou, identificationNo, confirmed: confirmationIcon, timestamp, print, reportAdverse },
      theme: { btnDark },
      monthNames,
    },
  } = useData();

  const getMonthName = m => {
    const months = [];
    for (const key in monthNames) {
      months.push(key);
    }
    return months[m];
  };

  // TODO replace with separate fields in json
  const [title, description] = thankyou.split('.');
  const nowDate = new Date();
  return (
    <QuizInner fullWidth>
      <Box $p={[20, 0]} $align="center">
        {confirmationIcon && <QuizConfirmationImg src={`${assetsPath}/${confirmationIcon}`} />}
        {title && (
          <Heading $align="center" $color="success" as="h2" $size="h2" $m={[0, 0, 25]}>
            {title}
          </Heading>
        )}
        {description && (
          <Text $size="sm" $m={[0, 0, 8]}>
            {description}
          </Text>
        )}
        <Text $size="sm" $m={[0, 0, 25]}>
          <b>{identificationNo}</b>
        </Text>
        <Box $bgColor="grayLighter" $radius={8} $p={[15, 25]} $m={[0, 0, 25]}>
          <Text $size="xl" $m={[0]}>
            <b>{intakeId}</b>
          </Text>
        </Box>
        <Text $size="sm" $m={[0, 0, 25]}>
          <b>{timestamp}</b>:{' '}
          {`${
            nowDate.getDate().toLocaleString().length === 1
              ? `0${nowDate.getDate().toLocaleString()}`
              : nowDate.getDate().toLocaleString()
          }-${getMonthName(nowDate.getMonth())}-${nowDate.getFullYear()}`}
        </Text>
        <Box $display="flex" $justifyContent="center">
          <Button onClick={() => window?.print()} $defaultColor={{ ...btnDark }} $color="red">
            <IconPrinter $size={18} $m={[0, 10, 0, 0]} />
            {print}
          </Button>
        </Box>

        <Box $display="flex" $justifyContent="center" $mt={20}>
          <QuizStyledLink href={Route.HOME}>{reportAdverse}</QuizStyledLink>
        </Box>
      </Box>
    </QuizInner>
  );
};

export default QuizFieldGroupConfirm;
